export { default as SmartLayout } from './SmartLayout';
export type { Direction, SectionBase, SmartLayoutProps } from './SmartLayout';
